<div mat-dialog-title id="selectAttributesTitle">{{ 'SelectAttributesTitle' | translate:locale.language }}</div>
<div mat-dialog-content>
  <div class="collection">
    <ng-container *ngFor="let attribute of attributes">
      <a href="javascript:;" class="collection-item as-blue-highlight"
        id="attributeItem"
        (click)="onSelect(attribute)"
        [class.active]="isSelected(attribute)">{{ attribute.name }}</a>
    </ng-container>
  </div>
</div>